import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

import './style.css';

import graphShadow from '../../Assets/chart-shadow.png';



// Constants
const GRAPH_HEIGHT_RATIO = 0.75;

const getRoundedValue = (num = 0) => parseFloat(Math.round(parseFloat(num * 10).toFixed(2))/10).toFixed(1)


export default class GraphMetricCircular extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            graphHeight: 0,
            graphWidth: 0,
            footerHeight: 0
        };

        this.options = Object.assign({}, options, this.props.options);
    }


    // Lifecycle Methods

    render() {
        return (
        <div ref={(e) => {this.rootElement = e}}
            className="hsg-gmc-root"
            style={{width: this.props.heightBound ? this.state.graphWidth : '100%'}}>

            {/* Graph container */}
            <div
                className="hsg-gmc-graph-container"
                style={{height: this.state.graphHeight}}>

                {/* Background Circle */}
                <div
                    className="hsg-gmc-graph-background"
                    style={{borderColor: this.options.backgroundCircleColor}}>

                </div>


                {/* Content Container */}
                <div className="hsg-gmc-metric-content-container">

                    {(Boolean(this.props.metricGlyph) &&
                        <div className="hsg-gmc-metric-glyph-holder"
                            style={{color: this.options.glyphColor}}>

                            <Glyphicon glyph={this.props.metricGlyph} />

                        </div>)

                    ||
                    
                    (Boolean(this.props.metricIcon) &&
                        <div className="hsg-gmc-metric-icon-holder"><img src={this.props.metricIcon} /></div>)}


                    <p className="hsg-gmc-metric-name"
                        style={{color: this.options.textColor}}>

                        {this.props.metricName || ''}

                    </p>


                    <p className="hsg-gmc-metric-value"
                        style={{color: this.options.metricValueColor}}>

                        {Boolean(this.props.metricValue) ? (this.props.metricName === "CURRENT BMI" ? getRoundedValue(this.props.metricValue) : this.props.metricValue) : 'NA'}

                    </p>


                    {Boolean(this.props.metricUnit) &&
                        <p className="hsg-gmc-metric-unit"
                            style={{color: this.options.textColor}}>

                            {this.props.metricUnit || ''}

                        </p>}

                </div>

            </div>


            {/* Graph Footer */}
            <div
                className="hsg-gmc-footer-container"
                style={{height: this.state.footerHeight}}>

                <img className="hsg-gmc-footer-image" src={graphShadow} />

            </div>

        </div>);
    }


    componentDidMount() {
        if(this.props.heightBound && this.props.height) {
            this.setHeightBoundState(this.props.height);
        }

        else {
            this.setWidthBoundState();
        }
    }

 
    componentWillReceiveProps(newProps) {
        this.options = Object.assign({}, options, newProps.options);

        if(this.props.heightBound != newProps.heightBound) {
            if(newProps.heightBound && newProps.height) {
                this.setHeightBoundState(newProps.height);
            }
    
            else {
                this.setWidthBoundState();
            }
        }

        else if(newProps.heightBound && newProps.height && this.props.height !== newProps.height) {
            this.setHeightBoundState(newProps.height);
        }

        else if(!newProps.heightBound && this.props.dim.width !== newProps.dim.width) {
            this.setWidthBoundState();
        }
    }


    // Other Methods

    setHeightBoundState(height) {
        const graphHeight = height * GRAPH_HEIGHT_RATIO;
        const footerHeight = height - graphHeight;

        this.setState({
            graphHeight,
            footerHeight,
            graphWidth: graphHeight
        });
    }


    setWidthBoundState() {
        const graphWidth = this.rootElement.offsetWidth;
        const footerHeight = Math.floor((graphWidth / GRAPH_HEIGHT_RATIO) - graphWidth);

        this.setState({
            graphHeight: graphWidth,
            graphWidth,
            footerHeight
        });
    }

}



GraphMetricCircular.propTypes = {
    heightBound: PropTypes.bool.isRequired,
    height: PropTypes.number,
    dim: PropTypes.shape({
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired
    }).isRequired,

    metricName: PropTypes.string.isRequired,
    metricValue: PropTypes.number.isRequired,
    metricUnit: PropTypes.string,
    metricIcon: PropTypes.string,
    metricGlyph: PropTypes.string,

    options: PropTypes.object
};



const options = {
    backgroundCircleColor: '#cccccc',
    metricValueColor: '#666666',
    textColor: '#999999',
    glyphColor: '#999999'
};